import React from 'react'
import '../assets/styles/components.css'

function HeaderText() {
  return (
    <div className="header">
      <h1>PDAK Training Feedback Form - TRN03</h1>
      <p>Hello Partner,</p>
      <p>
        Thank you for participating in the training. We hope you found it
        informative and enlightening. We'd like to hear your feedback so we can
        keep improving the GIG Learning experience. Please fill this quick
        survey and let us know your thoughts.{" "}
      </p>
    </div>
  );
}

export default HeaderText